import { Component, OnInit, ViewChild, inject } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { DxScrollViewModule, DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view'
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ThomasDockComponent } from '../../shared/thomas/thomas-dock.component';

// Navigation lives in the top bar now (app-header tabs + 9-dots app
// switcher); the old dx-drawer / side-navigation-menu is gone and the
// content fills the full width under the 40px bar.
@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    imports: [HeaderComponent, DxScrollViewModule, ThomasDockComponent]
})
export class SideNavOuterToolbarComponent implements OnInit {
  private router = inject(Router);

  @ViewChild(DxScrollViewComponent, { static: true }) scrollView!: DxScrollViewComponent

  private lastUrl = ''

  ngOnInit() {
    // preserve the old drawer behaviour of scrolling back to the top on navigation,
    // but not when only switching dashboards within the /dashboard route
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const staysOnDashboard = this.lastUrl.startsWith('/dashboard') && val.urlAfterRedirects.startsWith('/dashboard')
        this.lastUrl = val.urlAfterRedirects
        if (!staysOnDashboard) {
          this.scrollView?.instance?.scrollTo(0)
        }
      }
    })
  }
}
